import $ from 'jquery';

export default {
  install(Vue, options) {
    let notif = {
      success({ title, content, number }) {
        $.bigBox({
          title,
          content,
          color: '#739E73',
          icon: 'fa fa-check',
          number
        });
      },
      error({ title, content, number }) {
        $.bigBox({
          title,
          content,
          color: '#C46A69',
          icon: 'fa fa-warning shake animated',
          number
        });
      },
      info({ title, content, number }) {
        $.bigBox({
          title,
          content,
          color: '#3276B1',
          icon: 'fa fa-bell swing animated',
          number
        });
      },
      warning({ title, content, number }) {
        $.bigBox({
          title,
          content,
          color: '#C79121',
          icon: 'fa fa-shield fadeInLeft animated',
          number
        });
      }
    };

    if (!Vue.$notif) {
      Vue.$notif = notif;
    }

    Vue.prototype.$notif = Vue.$notif;

    Vue.mixin({
      created() {
        this.$notif = Vue.$notif;
      }
    });
  }
};
